<template>
  <div class="join_group" :class="{'isiOSX1':isiOSX, 'notApp':notApp}">
    <van-nav-bar
      title="入群赚取推广奖励"
      :fixed="true"
      left-arrow
      @click-left="goBack"
      :class="{'isiOSX':isiOSX}"
    />
    <div class="box">
      <div class="content"  v-show="step!=3">
        <p class="title">您将加入</p>
        <p class="label">销巴会员手机号<span>{{mobile}}</span>的群</p>
        <img class="line" src="../../assets/xiaobaGroup/bg_line@2x.png" />
        <van-row class="user-links">
          <van-cell-group v-show="step==1">
            <van-field class="mobile" v-model="phone" label="会员手机号" placeholder="输入您的销巴会员手机号" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" maxlength="12" />
            <van-button class="submit" size="large" @click="next">下一步</van-button>
          </van-cell-group>
          <van-cell-group v-show="step==2">
            <van-field class="varify" v-model="code" label="验证码" placeholder="请输入验证码" type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')">
              <van-button slot="button" size="small" @click="getvarify" v-if="downcounttime == 0">重新获取</van-button>
              <van-button class="downcount" slot="button" size="small" v-if="downcounttime == 1">{{down}}s后重新获取</van-button>
            </van-field>
            <van-button class="submit" size="large" @click="submit">提交并加入该群</van-button>
          </van-cell-group>
        </van-row>
        <p class="tip">一旦入群成功，不可更改</p>
      </div>
      <div class="success"  v-show="step==3">
        <p class="icon"><img src="../../assets/xiaobaGroup/successed@2x.png" /></p>
        <p class="title">恭喜您已成功加入</p>
        <p class="tip">销巴会员手机号<span>{{mobile}}</span>的群</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      phone: '',
      code: '',
      downcounttime: 1,
      down: 60,
      step: 1,
      mobile: '',
		  getVerifyNum: 0,
		  stopGet: '',
      flag: 0,
      notApp: false
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.mobile = this.$route.query.mobile;
    this.notApp = !this.$route.query.isApp;
  },
  mounted() {
    document.documentElement.style.setProperty('font-size', document.body.clientWidth / 375 * 10 + 'px');
    setTimeout(()=>{
      document.querySelector(".mobile input").focus();
    },500);
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
    next() {
	    this.verigyPhone();
      this.$api
        .post("/member-relation/index/check/member/join/group", {phone: this.phone, recommend_id: this.$route.query.member_id})
        .then(res => {
          this.step = 2;
          setTimeout(()=>{
            document.querySelector(".varify input").focus();
          },500)
          this.getvarify();
        })
        .catch(err => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    getvarify() { 
    	if(this.getVerifyNum < 5) {
    		this.getVerifyNum++;
	      this.verigyPhone();
	      const _this = this;
	      this.$api.post("/pushmsg/index/sms/send-code",
		    	{
		    		mobile: this.phone,
		    		type: 37
		    	}).then(res => {
		        _this.down = 60;
	          const timer = setInterval(function(){
	            _this.down--;
	            _this.downcounttime = 1;
	            if(_this.down <= 0){
	              clearInterval(timer);
	              _this.downcounttime = 0;
	            }
	          }, 1000);
	          _this.$toast('验证码已发送，请注意查收'); 
			    }).catch(err => {
			      let keys = Object.keys(err);
			     	let key = keys[0];
			  		let message = err.message || err[key][0]
				    if(message.slice(0, 10) == 'timeout of') {
			  			this.$toast('网络不给力，请稍候重试');
			  		}else {
			  			this.$toast(message);
			  		}
			    });
      }else {
      	var current = Math.floor(new Date().getTime() / 1000);
      	var tip = '';
      	if(this.getVerifyNum == 5) {
      		this.getVerifyNum++;
      		this.stopGet = current + 60 *15;
      	}
      	var ts = this.stopGet - current;
      	var mm = Math.floor(ts / 60);
				var ss = ts - mm *60;
				if(mm && ss) {
					tip = '获取验证码次数已超过5次，请过'+mm+'分钟'+ss+'秒之后再试。';
				}else if(mm && !ss) {
					tip = '获取验证码次数已超过5次，请过'+mm+'分钟之后再试。';
				}else if(!mm && ss) {
					tip = '获取验证码次数已超过5次，请过'+ss+'秒之后再试。';
				}
      	this.$toast(tip);
      }
  	},
    submit() {
      this.verigyPhone();
      if(!this.code) {
        this.$toast('请输入验证码');
        return false;
      }
      if(this.flag == 0) {
        this.flag = 1;
        this.$api
          .post("/member-relation/index/member/join/group", {phone: this.phone, code: this.code, recommend_id: this.$route.query.member_id})
          .then(res => {
            this.step = 3;
          })
          .catch(err => {
            this.flag = 0;
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          });
        }
    },
    verigyPhone() {
      if(this.phone == '') {
        this.$toast('请输入手机号')
        return false;
      }else if(/^1\d{10}$/.test(this.phone)) {
        // return true;
      }else {
        this.$toast('手机号格式错误');
        return false;
      }
    }
  }
};
</script>
<style>
  html {
    font-size: calc(var(--sizeScale2) * 10px);
  }
  .van-field__button {
    padding: 0;
  }
  .van-field__label {
    color: #333;
    font-size: 1.7rem;
    font-weight: bold;
  }
  .van-field__control {
    color: #333;
    font-size: 1.7rem;
  }
  input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color: #ccc !important;
  }
  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #ccc !important;
  }
  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #ccc !important;
  }
  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #ccc !important;
  }
  .mobile .van-field__label {
    width: 9.7rem;
  }
  .varify .van-field__label {
    width: 6.8rem;
  }
</style>
<style lang="less" scoped>
.join_group {
  min-height: 100%;
  box-sizing: border-box;
  background: #F9591B;
  padding-top: 72px;
  /deep/.van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 28px;
    border: none;
    box-shadow: none;
    background: #F9591B;
    overflow: hidden;
    .van-nav-bar__title {
      color: #ffffff;
      font-size: 1.8rem;
      font-weight: 400;
    }
    .van-nav-bar__text {
      color: #ffffff;
      font-size: 1.6rem;
      font-weight: 400;
      padding: 0 1.2rem;
    }
    .van-icon {
      color: #ffffff;
    }
  }
  .van-hairline--bottom:after {
    border-bottom-width: 0px !important;
  }
  .isiOSX {
    padding-top: 44px;
  }
  .box {
    padding: 0.7rem 1.8rem 0;
    .content {
      height: 29.7rem;
      background: url(../../assets/xiaobaGroup/bg@2x.png) no-repeat center center;
      background-size: 100% 100%;
      padding: 3rem 1.4rem 2.4rem;
		  box-sizing: border-box;
      .title {
        color: #333;
        font-size: 2.2rem;
        text-align: center;
        height: 2.6rem;
        line-height: 2.6rem;
        font-weight: bold;
      }
      .label {
        text-align: center;
        color: #666;
        font-size: 1.5rem;
        height: 2.4rem;
        line-height: 2.4rem;
        margin: 0.9rem 0 2.9rem;
        span {
          color: #F9591B;
        }
      }
      .line {
        width: 100%;
        height: 0.2rem;
        display: block;
      }
      .van-hairline--top-bottom::after {
	      border-width: 0 0; 
	    }
      .van-cell-group {
	      .van-cell{
	        padding: 1.4rem 0;
          margin-top: 1.4rem;
	        background: rgba(255, 255, 255, 0);
          .van-button{
	          color: #F9591B;
	          border: none;
	          font-size: 1.7rem;
	          height: 2.2rem;
	          line-height: 2.2rem;
	          padding-left: 2rem;
	          padding-right: 0;
	          font-weight: bold;
	          border-left: solid 1px #eee;
	        }
	        .downcount{
	          color: #ccc;
	          padding-left: 1.1rem;
	        }
	      }
	      .submit {
	        color: #fff;
	        font-size: 1.6rem;
	        height: 4.2rem;
	        line-height: 4.2rem;
	        border: none;
	        border-radius: 2.1rem;
          margin-top: 1.5rem;
	        background: -webkit-linear-gradient(to right, #FC740C, #F41A3C); /* Safari 5.1 - 6.0 */
	        background: -o-linear-gradient(to right, #FC740C, #F41A3C); /* Opera 11.1 - 12.0 */
	        background: -moz-linear-gradient(to right, #FC740C, #F41A3C); /* Firefox 3.6 - 15 */
	        background: linear-gradient(to right, #FC740C, #F41A3C);
	      }
	      .van-cell::after {
	        content: ' ';
	        position: absolute;
	        pointer-events: none;
	        -webkit-box-sizing: border-box;
	        box-sizing: border-box;
	        left: 0px;
	        right: 0;
	        bottom: 0;
	        /*-webkit-transform: scaleY(0.5);
	        transform: scaleY(0.5);*/
	        border-bottom: 1px solid #ebedf0;
	      }
	    }
      .tip {
        color: #999;
        font-size: 1.3rem;
        text-align: center;
        line-height: 2.1rem;
        margin: 0.9rem 0 0;
      }
    }
    .success {
      height: 17.9rem;
      padding: 3rem;
      border-radius: 0.8rem;
		  box-sizing: border-box;
      text-align: center;
      background: #fff;
      .icon {
        img {
          width: 4.5rem;
          display: inline-block;
        }
      }
      .title {
        color: #333;
        font-size: 2.2rem;
        font-weight: bold;
        margin: 2.4rem 0 0.9rem;
      }
      .tip {
        color: #666;
        font-size: 1.5rem;
        span {
          color: #F9591B;
        }
      }
    }
  }
}
.isiOSX1 {
  padding-top: 88px;
}
.notApp {
  padding-top: 0;
  .van-nav-bar {
    display: none;
  }
}
</style>


